module.exports = __webpack_public_path__ + "85c66f70e07daf430021945d0b7263e7.png";